<template>
    <div class="col-12">
        <a class="post-cards__download" :href="post.acf.file.url" download>
            <div class="tag">
                {{ post.acf.file.subtype }}
            </div>
            <div class="content">
                <h3 class="title" v-html="post.title.rendered"></h3>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
                <path fill="#47BBE3" d="m10.9997 16.5668-6.43336-6.4333 1.43333-1.43334 4 4.00004V.333496h2.00003V12.7002l4-4.00004 1.4333 1.43334-6.4333 6.4333Zm-8.66669 5.1c-.53334 0-1-.2-1.400002-.6-.4-.4-.6-.8666-.6-1.4v-4.7666H2.33301v4.7666H19.6663v-4.7666h2v4.7666c0 .5334-.2 1-.6 1.4-.4.4-.8666.6-1.4.6H2.33301Z"/>
            </svg>
        </a>
    </div>
</template>

<script>

    export default {
        props: ['post'],
    }
</script>